import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Link,
  Alert,
  useTheme,
} from "@mui/material";
import { AuthContext } from "../../theme/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginUser } from "../../api/authAPI";

export default function Login() {
  const theme = useTheme();
  const { login, user } = useContext(AuthContext);
  console.log("Current User in Login Component:", user);
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("")

  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId");

  useEffect(() => {
    if (user && courseId) {
      navigate(`/checkout?courseId=${courseId}`);
    }
  }, [user, courseId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await loginUser(form.email, form.password);
      if (
        !data ||
        !data.data ||
        !data.data.idToken ||
        !data.data.idToken.jwtToken
      ) {
        console.error("Invalid credentials:", data);
        setError("Invalid email or password. Please try again.");
        return;
      }

      // Extract token
      const token = data.data.idToken.jwtToken;

      // Prepare user details safely
      const payload = data.data.idToken.payload || {};
      console.log("Login Payload:", payload);

      const userData = {
        email: payload.email || form.email,
        username: payload.preferred_username || payload["cognito:username"] || form.email,
        phone: payload.phone_number || "",
        name: payload.name || "",
      };
      login(userData, token);
      if (courseId) {
        navigate(`/checkout?courseId=${courseId}`);
      } else {
        navigate("/");
      }

    } catch (error) {
      console.error("Login failed:", error);
      alert("Login failed: Invalid credentials or network issue.");
    }
  };



  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: 420 },
        mx: "auto",
        px: { xs: 2, sm: 0 },
      }}
    >
      {/* Logo */}
      <Box textAlign="center" mb={{ xs: 2, sm: 3 }}>
        <Box
          component="img"
          src="/topperhub.png"
          alt="TopperHub"
          sx={{

            height: { xs: 44, sm: 56 },
            mb: 1,
            filter:
              theme.palette.mode === "dark"
                ? "brightness(1.1)"
                : "none",
          }}
        />
      </Box>

      <Typography
        variant="h4"
        fontWeight={500}
        textAlign="center"
        mb={{ xs: 1.5, sm: 3 }}
        fontSize={{ xs: "1.6rem", sm: "2.125rem" }}
        color={theme.palette.text.primary}
      >
        Welcome Back
      </Typography>

      <Typography
        variant="body1"
        textAlign="center"
        mb={{ xs: 3, sm: 4 }}
        fontSize={{ xs: "0.95rem", sm: "1rem" }}
        color={theme.palette.text.secondary}
      >
        Login to continue your learning journey
      </Typography>

      <form onSubmit={handleSubmit}>
        <Stack spacing={{ xs: 2.5, sm: 3 }}>
          <TextField
            label="Email"
            type="text"
            fullWidth
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          />

          <Link
            underline="none"
            sx={{
              cursor: "pointer",
              color: theme.palette.primary.main,
              fontSize: "14px",
              textAlign: { xs: "center", sm: "right" },
            }}
            onClick={() => navigate("/forgotPassword")}
          >
            Forgot Password?
          </Link>

          <Button
            variant="contained"
            type="submit"
            fullWidth
            sx={{
              borderRadius: "12px",
              paddingY: 1.2,
              background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "15px", sm: "16px" },
              color: theme.palette.primary.contrastText,
            }}
          >
            Login
          </Button>

          {error && (
            <Alert
              severity="error"
              sx={{
                fontSize: "14px",
                borderRadius: "10px",
              }}
            >
              {error}
            </Alert>
          )}

          <Typography
            textAlign="center"
            mt={1}
            fontSize={{ xs: "0.9rem", sm: "1rem" }}
            color={theme.palette.text.secondary}
          >
            Don’t have an account?{" "}
            <Link
              sx={{ cursor: "pointer", color: theme.palette.primary.main }}
             onClick={() => navigate(`/signup?courseId=${courseId || ""}`)}
              underline="none"
            >
              Create one
            </Link>
          </Typography>
        </Stack>
      </form>
    </Box>

  );
}
